import { WeaveSkeletonItem } from '../WeaveSkeletonItem/WeaveSkeletonItem';

interface SkeletonLoaderProps {
	title: string;
	loading: boolean;
}

const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({ title, loading }) => {
	if (loading)
		return (
			<div
				style={{
					width: '100%',
				}}
			>
				<p>{title}</p>
				<WeaveSkeletonItem height="15px" width="100%" radius="2px" />
				<WeaveSkeletonItem height="15px" width="100%" radius="2px" />
				<WeaveSkeletonItem height="15px" width="100%" radius="2px" />
			</div>
		);
};

export default SkeletonLoader;
